export default "__VITE_ASSET__CpTMG1c6__"